import type { ColumnsType } from "@similarweb/pro-logic-components";

import { translate } from "app/filters/i18nFilter";
import ContactNameCell from "app/pages/sales-intelligence/sub-modules/contacts-search/components/cells/ContactNameCell/ContactNameCell";
import EngageActionsCell from "app/pages/sales-intelligence/sub-modules/contacts-search/components/cells/EngageActionsCell/EngageActionsCell";
import type { ContactsTableColumnsExternalProps } from "app/pages/sales-intelligence/sub-modules/contacts-search/configuration/columns/createContactsResultsTableColumns";
import { createAllColumnsConfigFactory } from "app/pages/sales-intelligence/sub-modules/contacts-search/configuration/columns/createContactsResultsTableColumns";
import { createRegularContactColumn } from "app/pages/sales-intelligence/sub-modules/contacts-search/configuration/columns/utils";
import type { ContactSearchEntry } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";
import { formatNumberWithLimit } from "app/pages/sales-intelligence/utils/numbers";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

export const createContactsResultsListTableColumns = ({
    onExportItemToExel,
    onExportItemToCRM,
    totalCount,
    onRefetchData,
}: ContactsTableColumnsExternalProps): ColumnsType<ContactSearchEntry> => {
    const allColumnsConfig = createAllColumnsConfigFactory({
        onExportItemToExel,
        onExportItemToCRM,
        totalCount,
        onRefetchData,
    });

    return [
        createRegularContactColumn("name", {
            title: translate(
                is.undefined(totalCount)
                    ? `si.contacts_search.table.column.name.title`
                    : `si.contacts_search.table.column.name.title-with-count`,
                {
                    totalCount: formatNumberWithLimit(totalCount),
                },
            ),
            fixed: true,
            width: 198,
            render: (value: string, rowData: ContactSearchEntry) => (
                <ContactNameCell
                    value={value}
                    rowData={rowData}
                    withLink={false}
                />
            ),
        }),
        ...(allColumnsConfig.linkedin || []),
        ...(allColumnsConfig.companyName || []),
        ...(allColumnsConfig.privateData || []),
        createRegularContactColumn("hasDirectPhoneNumbers", {
            title: translate("si.contacts_search.table.column.actions.title"),
            width: 106,
            className: "column-overflow-visible",
            render: (_: unknown, rowData: ContactSearchEntry, index: number) => (
                <EngageActionsCell
                    actionButtonDataAutomation={`contact-button.more-actions.index-${index}`}
                    rowData={rowData}
                    onExportItemToCRM={onExportItemToCRM}
                    onExportItemToExel={onExportItemToExel}
                    viewType="list"
                />
            ),
        }),
        ...(allColumnsConfig.title || []),
        ...(allColumnsConfig.department || []),
        ...(allColumnsConfig.numericCountryCode || []),
        ...(allColumnsConfig.accuracyGrade || []),
        ...(allColumnsConfig.isRevealed || []),
    ];
};
